import Account from './pages/account/account';

document.addEventListener('DOMContentLoaded', (e) => {
  new Account().init();
});
